export const KIOSK_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export type KioskStatus =
  | (typeof KIOSK_STATUS)[keyof typeof KIOSK_STATUS]
  | string;

export type KioskRecord = {
  kioskId: number;
  kioskUuid: string | null;
  organizationId: number;
  locationId: number | null;
  kioskName: string;
  deviceId: string | null;
  deviceName: string | null;
  deviceIdentifier: string | null;
  status: KioskStatus;
  activatedAt: string | null;
  lastSeenAt: string | null;
  activationTokenExpiresAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  rowVersion: number | null;
};

export type KioskListFilters = {
  status?: KioskStatus | null;
};

export type KioskListResult = {
  items: KioskRecord[];
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
};

export type KioskRegisterInput = {
  kioskName: string;
  deviceName?: string | null;
  deviceIdentifier?: string | null;
  locationId?: number | null;
};

export type KioskActivationTokenResult = {
  kiosk: KioskRecord;
  activationToken: string;
  expiresAt: string;
};

export type KioskActivationStatus = {
  kioskId: number;
  organizationId: number;
  status: KioskStatus;
  activatedAt: string | null;
  activationTokenExpiresAt: string | null;
  isActivated: boolean;
  isPending: boolean;
};

export type KioskAuthSession = {
  kiosk: KioskRecord;
  accessToken: string;
  refreshToken: string;
  refreshTokenExpiresAt: string | null;
  tokenType: string;
};

export type StoredKioskSession = {
  accessToken: string;
  refreshToken: string;
  kioskId: number;
  organizationId: number;
  deviceIdentifier: string;
  kioskName?: string | null;
};
